<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="credit"><span class="epub-b">PICTURE CREDITS</span></p>
<p class="tni"><a href="#/xhtml/chapter1#pg6">Maison de Nostradamus, Salon-de-Provence</a></p>
<p class="tni"><a href="#/xhtml/chapter2#pg18">Faculty of Medicine, Montpellier</a></p>
<p class="tni"><a href="#/xhtml/chapter2#pg26">Musée Condé, Chantilly</a></p>
<p class="tni"><span href="#/xhtml/chapter7#pg96" title="Link target outside of Sample">Musée du Louvre/Réunion des Musées Nationaux</span></p>
<p class="tni"><span href="#/xhtml/chapter11#pg157" title="Link target outside of Sample">Musée du Louvre/Réunion des Musées Nationaux</span></p>
<p class="tni"><span href="#/xhtml/chapter9#pg122" title="Link target outside of Sample">Bibliothèque Nationale, Paris</span></p>
<p class="tni"><span href="#/xhtml/chapter10#pg134" title="Link target outside of Sample">Bibliothèque Nationale, Paris</span></p>
<p class="tni"><span href="#/xhtml/chapter13#pg181" title="Link target outside of Sample">Bibliothèque Nationale, Paris</span></p>
<p class="tni"><span href="#/xhtml/chapter11#pg153" title="Link target outside of Sample">Bibliothèque Ste-Geneviève, Paris</span></p>
<p class="tni"><span href="#/xhtml/chapter11#pg159" title="Link target outside of Sample">Bibliothèque du Conservatoire des Arts et Métiers</span></p>
<p class="tni"><span href="#/xhtml/chapter14#pg198" title="Link target outside of Sample">National Portrait Gallery, London</span></p>
<p class="tni"><span href="#/xhtml/chapter15#pg208" title="Link target outside of Sample">Kunsthistorisches Museum, Vienna</span></p>
<p class="tni"><span href="#/xhtml/chapter15#pg212" title="Link target outside of Sample">Kungl. Biblioteket, the Royal Library, Stockholm</span></p>
<p class="tni"><span href="#/xhtml/chapter15#pg215" title="Link target outside of Sample">Kungl. Biblioteket, the Royal Library, Stockholm</span></p>
<p class="tni"><span href="#/xhtml/chapter18#pg256" title="Link target outside of Sample">Albertina Collection, Vienna</span></p>
<p class="tni"><a href="#/xhtml/chapter1#pg3b">Judith Wilson</a></p>
<p class="tni"><a href="#/xhtml/chapter1#pg3c">Judith Wilson</a></p>
<p class="tni"><a href="#/xhtml/chapter1#pg5">Judith Wilson</a></p>
<p class="tni"><a href="#/xhtml/chapter1#pg9">Judith Wilson</a></p>
<p class="tni"><a href="#/xhtml/chapter1#pg11">Judith Wilson</a></p>
<p class="tni"><span href="#/xhtml/chapter3#pg32" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter4#pg50" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter5#pg56" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter6#pg70" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter6#pg81" title="Link target outside of Sample">Judith Wilson (courtesy of the Bibliothèque Municipale, Albi)</span></p>
<p class="tni"><span href="#/xhtml/chapter7#pg91" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter8#pg110" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter8#pg112" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter13#pg194" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter16#pg221" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter17#pg237" title="Link target outside of Sample">Judith Wilson (courtesy of the Bibliothèque Municipale, Albi)</span></p>
<p class="tni"><span href="#/xhtml/chapter17#pg241" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter17#pg242" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter18#pg263" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter19#pg270" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter19#pg273" title="Link target outside of Sample">Judith Wilson</span></p>
<p class="tni"><span href="#/xhtml/chapter20#pg287" title="Link target outside of Sample">Judith Wilson</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// credit.vue?00c9af12